/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["ui-nuget-versions-grid{position:relative}ui-nuget-versions-grid .action-remove-all-inactive{z-index:1;position:absolute;top:10px}"];
export { styles as styles };
